import { ORDER_INVOICE_LIST } from './invoiceTypes'

export default {
    [ORDER_INVOICE_LIST](state, data) {
        state.invoiceList = data;
    },
}
